export enum Tab {
  Distribution = 'distribution',
  Evaluation = 'evaluation',
}
